import { useState } from 'react';
import html2pdf from 'html2pdf.js';

const useGeneratePDF = (setIsGeneratingPDF) => {
    const [generatingPDF, setGeneratingPDF] = useState(false);
    const [error, setError] = useState(null);

    const generatePDF = async (inputId, fileName) => {
        const input = document.getElementById(inputId); 
        setGeneratingPDF(true);
        setIsGeneratingPDF(true);
        try {
            // Wait for DOM/layout to update
            await new Promise(resolve => setTimeout(resolve, 100));

            // Subtract 2px to avoid extra blank page
            const contentHeight = input.scrollHeight - 2;

            await html2pdf()
                .set({
                    margin: 0,
                    filename: `${fileName}_Analysis_Report.pdf`,
                    image: { type: 'jpeg', quality: 1 },
                    html2canvas: {
                        scale: 2,
                        useCORS: true,
                        backgroundColor: '#ffffff',
                        logging: false,
                        allowTaint: true
                    },
                    jsPDF: {
                        unit: 'px',
                        format: [1200, contentHeight],
                        orientation: 'portrait'
                    },
                    pagebreak: { mode: [] }
                })
                .from(input)
                .save();
        } catch (error) {
            console.error('Error generating PDF:', error);
            setError('Failed to generate PDF report. Please try again or contact support if the issue persists.');
        } finally {
            setIsGeneratingPDF(false);
            setGeneratingPDF(false);
        }
    };

    return { generatePDF, generatingPDF, error };
};

export default useGeneratePDF; 